import {Outlet} from 'react-router-dom';
import OfflineBanner from './feedback/OfflineBanner';
import DraftBanner from './tell/DraftBanner';
import TabBar from './TabBar';
import {useTimezoneSync} from '../hooks/useTimezoneSync';

// The signed-in frame: a phone-width column with room for the tab bar. Phase 0 keeps the
// desktop as the same column; the map (Phase 4) is the first screen with a real desktop layout.
export default function AppShell() {
    useTimezoneSync();
    return (
        <>
            <main className="mx-auto w-full max-w-[560px] px-4 pb-[120px] pt-[max(12px,env(safe-area-inset-top))]">
                <OfflineBanner />
                <DraftBanner />
                <Outlet />
            </main>
            <TabBar />
        </>
    );
}

/** The signed-out frame: the same column, no tab bar. */
export function PublicShell() {
    return (
        <main className="mx-auto w-full max-w-[560px] px-4 pb-12 pt-[max(12px,env(safe-area-inset-top))]">
            <Outlet />
        </main>
    );
}
